/**
 * Created by prakash on 22/9/18.
 */

/**
 * A model for an Application listing
 */
export class ApplicationListDashboard {
    id:number;
    applicationName: string;
    ldapApplicationId: string;
    managerNames: string;
    customerNumberRequired: boolean;
    skipManagerApproval: boolean;
    multipleRole: boolean;
    status: string;
    active: boolean;
    createdAt: string;

    constructor(id:number, applicationName: string, ldapApplicationId: string, managerNames: string, customerNumberRequired: boolean,
                skipManagerApproval: boolean, multipleRole: boolean, status: string, active: boolean, createdAt: string){
        this.id = id;
        this.applicationName = applicationName;
        this.ldapApplicationId = ldapApplicationId;
        this.managerNames = managerNames;
        this.customerNumberRequired = customerNumberRequired;
        this.skipManagerApproval = skipManagerApproval;
        this.multipleRole = multipleRole;
        this.status = status;
        this.active = active;
        this.createdAt = createdAt;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationList-datatable/applicationList-dashboard.ts